import React from "react";
import { useNavigate } from "react-router-dom";
import AnalyticsChart from "../analytics/index";
import WidgetCard from "./card";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";

const WidgetTotalCustomer = () => {
  const navigate = useNavigate();
  function goToOtherCustomers() {
    navigate("/customers-list");
  }

  function renderFooter() {
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          kind={"secondary"}
          colorScheme={"ghost"}
          onClick={() => {
            goToOtherCustomers();
          }}
        >
          <FormattedMessage id="customersWidget.showAllCustomers" />
        </Button>
      </div>
    );
  }
  function renderChart() {
    return (
      <AnalyticsChart
        classChart=""
        idDivForChart="analyticsView-chart-customer-new"
        kpiName="TotalCostumersChart"
        metamodel={true}
      />
    );
  }

  return (
    <WidgetCard
      type={"box1_3"}
      titleWidget={
        <div>
          <FormattedMessage id="customersWidget.title" />
        </div>
      }
      customTitle={"titleWidgetCustomers"}
      footer={renderFooter()}
    >
      {renderChart()}
    </WidgetCard>
  );
};

export default WidgetTotalCustomer;
